export default __webpack_public_path__ + "static/media/sobre_mobile1000.718006c3.webp";